import React, {useEffect, useState} from "react";
import {Col, Container, Modal, Row, Button} from 'react-bootstrap';
import APICom from "../../../utils/helpers/APICom";
import axios from 'axios';
import { mainstore } from "../../../store";

//const mrms_reportingapi_url  = process.env.REACT_APP_MRMS_REPORTING_API;
const TripHistoryDialog = (props) => {
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [noDataAlert, setNoDataAlert] = useState({alertTitle: '', alertMsg: ''});
    const [ShowMainDialogue, setShowMainDialogue] = useState(true);
    const [showTripHistoryLoader, setShowTripHistoryLoader] = useState(false);
    const [showBidHistoryLoader, setShowBidHistoryLoader] = useState(false);

    function callAlertNoSignature() {
        setShowMainDialogue(false);
        setNoDataAlert({
            alertTitle: 'Alert',
            alertMsg: 'Unable to open report, please try again later.'
        });
        setDisplayNoDataAlert(true);
    }

    const handleCloseTripHistoryDialog = () => {
        if (props.showTripHistoryDialog) {
            props.setTripHistoryDialog(false);
        }
    };

    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
        if(ShowMainDialogue == false){
            handleCloseTripHistoryDialog();
        }
    };

    const handleTripHistoryReport = async () => {
        try {
            let lastIndex = (props.GridRowData ? props.GridRowData.length - 1 : 0);
            let bgridTypeStanding = (props.gridType && props.gridType === 'Standing');
            let bgridTypeComplete = (props.gridType && props.gridType === 'Complete');
            let rptType = (bgridTypeStanding ? "TimeCallDetailedHistoryReport" : (bgridTypeComplete ? 
                "Treated" : 
                (props.GridRowData[lastIndex].bIsSchedule ? "TimeCallDetailedHistoryReport" : "DetailHistoryServiceReport"))
            );
            let service_id = (bgridTypeStanding ? props.GridRowData[lastIndex].iScheduleID : props.GridRowData[lastIndex].ServiceID);
            let scheduleID = (props.GridRowData[lastIndex].iScheduleID ? props.GridRowData[lastIndex].iScheduleID : (props.GridRowData[lastIndex].ScheduleID ? props.GridRowData[lastIndex].ScheduleID : ""));

            if(!scheduleID){
                scheduleID = "-1";
            }
        
            const response = await APICom.fetchData("AspDotNetCoreURL", `TripHistoryReports/GetTripHistoryReportData?serviceID=${service_id}&scheduleID=${scheduleID}&rptType=${rptType}`, "get", {}, {});
            let json_data = response.data;
            if (json_data.Message == "Error!") {
                callAlertNoSignature();
                setShowTripHistoryLoader(false);
                // handleCloseTripHistoryDialog();
                return;
            }
            let mrms_reportingapi_url = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API;
            let url = mrms_reportingapi_url +'TripReport';
            if (rptType === "TimeCallDetailedHistoryReport") {
                url = mrms_reportingapi_url+ 'TimeCallDetailedHistoryReport';
            }
            const pdfResponse = await axios.post(url, json_data, {
                responseType: 'arraybuffer',
            });

            if (pdfResponse.status === 200) {
                const blob = new Blob([pdfResponse.data], {type: "application/pdf"});
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_blank');
                URL.revokeObjectURL(pdfUrl);
            } 
            else {
                callAlertNoSignature();
                console.error('Failed to fetch the report.');
            }
            setShowTripHistoryLoader(false);
        } 
        catch (error) {
            console.error(error);
            callAlertNoSignature();
            setShowTripHistoryLoader(false);
        }
    };

    const handleBidHistroyReport = async () => {
        try {
            let lastIndex = props.GridRowData.length - 1;
            let service_id = (props.gridType && props.gridType === 'Standing' ? props.GridRowData[lastIndex].iScheduleID : props.GridRowData[lastIndex].ServiceID);
            const response = await APICom.fetchData("AspDotNetCoreURL", `BidHistoryReports/GetBidHistoryReportData?serviceID=${service_id}`, "get", {}, {});
            let json_data = response.data;
            if (json_data.Message == "Error!") {
                callAlertNoSignature();
                // handleCloseTripHistoryDialog();
                return;
            }
            let mrms_reportingapi_url = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API;
            let url = mrms_reportingapi_url + 'ShowBidHistoryReport';

            const pdfResponse = await axios.post(url, json_data, {
                responseType: 'arraybuffer',
            });

            if (pdfResponse.status === 200) {
                const blob = new Blob([pdfResponse.data], {type: "application/pdf"});
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_blank');
                URL.revokeObjectURL(pdfUrl);
            } else {
                callAlertNoSignature();
                console.error('Failed to fetch the report.');
            }
            setShowBidHistoryLoader(false);
        } catch (error) {
            console.error(error);
            callAlertNoSignature();
            setShowBidHistoryLoader(false);
        }
    };

    useEffect(() => {

        if(!props.GridRowData || props.GridRowData.length <= 0)
        {
            //handleCloseTripHistoryDialog();
            setShowMainDialogue(false);
            setNoDataAlert({
                alertTitle: 'No Record Selected',
                alertMsg: 'Please select a record to generate report'
            });
            setDisplayNoDataAlert(true);
            console.log('displayNoDataAlert:', props.showTripHistoryDialog);
        }
    }, []);



    return (
        <>
            <Modal show={ShowMainDialogue} centered onHide={handleCloseTripHistoryDialog} backdrop="static"
                   keyboard={true} animation={true} size="md" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title className="activate_dialog_title_color user-select-none">Print Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example user-select-none">
                    <Container>
                        <Row>
                            
                            <Col className={`${props.gridType === 'Standing' ? "d-flex justify-content-center" : ""}`}>
                                <Button className={`${props.gridType !== 'Standing' ? "w-100" : ""} tripaction_btn_color`} value="Trip History" disabled={showTripHistoryLoader}
                                    onClick={(e)=>{setShowTripHistoryLoader(true); handleTripHistoryReport(e);}}>
                                    {showTripHistoryLoader ? <span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span> : "Trip History"}
                                </Button>
                            </Col>
                            
                            {props.gridType !== 'Standing'?
                                <Col>
                                    <Button className="tripaction_btn_color w-100" value="Bid History" disabled={showBidHistoryLoader}
                                        onClick={(e)=>{setShowBidHistoryLoader(true); handleBidHistroyReport(e);}}>
                                        {showBidHistoryLoader ? <span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span> : "Bid History"}
                                    </Button>
                                </Col>
                            : ""}
                            
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
            {displayNoDataAlert && (
                <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} keyboard={true} animation={true} backdrop="static">
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                        <Modal.Title className='noshow_dialog_title_color user-select-none'>
                            {noDataAlert.alertTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none">
                        <b>{noDataAlert.alertMsg}</b>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" onClick={handleAlertModalClose}>OK</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}

export default TripHistoryDialog;
